import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import PositionNotice from "@/views/MGT/position/components/position-notice.vue";
import ProChioseAddressBook from "@/components/pro-common/pro-chiose-modal/pro-chiose-address-book.vue";
import { saveTagAssociate } from "@/service/structure.js";
export default {
  name: "position-structure-add",
  components: {
    PositionNotice,
    ProChioseAddressBook
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    position: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "hidden",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      checkedList: [],
      tabsObj: {
        ORG: "departmemt",
        USER: "member",
        ALL: "structure"
      },
      tabs: []
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.tabs = [this.tabsObj[this.position.tagValue]];
      } else {
        this.tabs = [];
      }
    }
  },
  methods: {
    close() {
      this.checkedList = [];
      this.visible = false;
    },
    async onSubmit() {
      const params = {
        tagId: this.position.tagId,
        targetIds: this.checkedList.map(v => v.userId || v.orgId).join(",")
      };
      this.loading = true;
      let {
        data
      } = await saveTagAssociate(params);
      this.loading = false;
      if (data && data.result === 0) {
        // lg: 新增成功
        this.$Message.success($t("d76ha54", "新增成功"));
        this.$emit("onSuccess");
        this.close();
      }
    }
  }
};